export default __webpack_public_path__ + "static/media/03.c9622d7b.jpg";